import React, { useEffect, useState } from "react";
import { formatDuration, formatMSTDateTime } from "@/lib/timeUtils";

// Live timer driven from a started_at ISO string (UTC).
export const LiveTimer = ({ startedAt, large = false, testId = "live-timer" }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  if (!startedAt) return null;
  const seconds = Math.floor((now - new Date(startedAt).getTime()) / 1000);
  return (
    <div className="leading-none" data-testid={testId}>
      <div
        className={`font-mono ${large ? "text-6xl md:text-7xl" : "text-3xl"} tracking-tighter text-summit-ink`}
      >
        {formatDuration(seconds)}
      </div>
      <div className="font-mono text-[10px] uppercase tracking-widest text-gray-500 mt-2">
        Since {formatMSTDateTime(startedAt)} MST
      </div>
    </div>
  );
};
